/* global jQuery */
( function( $ ) {
	$( function() {
		$( '.nav-links.desktop-only > ul > li' ).off( 'mouseenter mouseleave' );
	} );

	$(function () {
		$('.accordion').click( function () {
			console.log('click');
			var $this = $(this)
			$this.toggleClass('active');
			var $panel = $this.next();
			var $carret = $this.children('.carret');
			if ($panel.hasClass('show') == false) {
				$carret.css( 'transform', 'rotate(180deg)')
				$panel.addClass('show');
			} else {
				$carret.css( 'transform', 'rotate(0deg)')
				$panel.removeClass('show');
			}
		});
	});
}( jQuery ) );